import { lazy } from "react";

// Auth & public
export const Login = lazy(() => import("@/pages/Login"));
export const LandingPage = lazy(() => import("@/pages/LandingPage"));
export const ResetPassword = lazy(() => import("@/pages/ResetPassword"));
export const MasterOnboarding = lazy(() => import("@/pages/MasterOnboarding"));
export const AcceptInvite = lazy(() => import("@/pages/AcceptInvite"));
export const AnamneseForm = lazy(() => import("@/pages/AnamneseForm"));
export const StudentRegistration = lazy(() => import("@/pages/StudentRegistration"));
export const ApproveStudent = lazy(() => import("@/pages/ApproveStudent"));
export const VideoDemo = lazy(() => import("@/pages/VideoDemo"));
export const NutritionKnowledgeBase = lazy(() => import("@/pages/NutritionKnowledgeBase"));
export const NotFound = lazy(() => import("@/pages/NotFound"));
export const ComparativoMFit = lazy(() => import("@/pages/ComparativoMFit"));
export const Portfolio = lazy(() => import("@/pages/Portfolio"));

// Chat / Kyra
export const KyraChat = lazy(() => import("@/pages/KyraChat"));
export const KyraLogin = lazy(() => import("@/pages/KyraLogin"));
export const KyraMobile = lazy(() => import("@/pages/KyraMobile"));
export const ChatInstall = lazy(() => import("@/pages/ChatInstall"));
export const ChatWelcome = lazy(() => import("@/pages/ChatWelcome"));

// Student
export const StudentApp = lazy(() => import("@/pages/StudentApp"));
export const StudentLogin = lazy(() => import("@/pages/StudentLogin"));
export const StudentOnboarding = lazy(() => import("@/pages/StudentOnboarding"));
export const StudentResetPassword = lazy(() => import("@/pages/StudentResetPassword"));
export const StudentTokenReset = lazy(() => import("@/pages/StudentTokenReset"));
export const StudentWorkout = lazy(() => import("@/pages/StudentWorkout"));
export const StudentWorkouts = lazy(() => import("@/pages/StudentWorkouts"));
export const StudentHistory = lazy(() => import("@/pages/StudentHistory"));
export const StudentChat = lazy(() => import("@/pages/StudentChat"));
export const StudentMessages = lazy(() => import("@/pages/StudentMessages"));
export const StudentInstall = lazy(() => import("@/pages/StudentInstall"));
export const StudentMyProfile = lazy(() => import("@/pages/StudentMyProfile"));
export const StudentEvolution = lazy(() => import("@/pages/StudentEvolution"));
export const StudentCheckin = lazy(() => import("@/pages/StudentCheckin"));
export const StudentHealth = lazy(() => import("@/pages/StudentHealth"));
export const StudentMealPlan = lazy(() => import("@/pages/StudentMealPlan"));
export const StudentNutritionQuestionnaire = lazy(() => import("@/pages/StudentNutritionQuestionnaire"));
export const StudentJournal = lazy(() => import("@/pages/StudentJournal"));

// Professor
export const Index = lazy(() => import("@/pages/Index"));
export const StudentProfile = lazy(() => import("@/pages/StudentProfile"));
export const AdminAnamneses = lazy(() => import("@/pages/AdminAnamneses"));
export const AdminAnamneseDetail = lazy(() => import("@/pages/AdminAnamneseDetail"));
export const ExerciseLibrary = lazy(() => import("@/pages/ExerciseLibrary"));
export const BulkMediaUpload = lazy(() => import("@/pages/BulkMediaUpload"));
export const WorkoutTemplates = lazy(() => import("@/pages/WorkoutTemplates"));
export const ProfessorSettings = lazy(() => import("@/pages/ProfessorSettings"));
export const MasterStaffManagement = lazy(() => import("@/pages/MasterStaffManagement"));
export const BusinessMetrics = lazy(() => import("@/pages/BusinessMetrics"));
export const Financeiro = lazy(() => import("@/pages/Financeiro"));
export const NutritionReview = lazy(() => import("@/pages/NutritionReview"));
export const NutritionConfigPage = lazy(() => import("@/pages/NutritionConfig"));
export const NutritionStudents = lazy(() => import("@/pages/NutritionStudents"));
export const NutritionStudentProfile = lazy(() => import("@/pages/NutritionStudentProfile"));
export const NutritionistSettings = lazy(() => import("@/pages/NutritionistSettings"));

// Owner / Admin
export const OwnerAdmin = lazy(() => import("@/pages/OwnerAdmin"));
export const OwnerPlans = lazy(() => import("@/pages/OwnerPlans"));
export const OwnerLogs = lazy(() => import("@/pages/OwnerLogs"));
export const OwnerConfig = lazy(() => import("@/pages/OwnerConfig"));
export const OwnerStaffManagement = lazy(() => import("@/pages/OwnerStaffManagement"));
export const AIUsageDashboard = lazy(() => import("@/pages/AIUsageDashboard"));
export const NutritionRevenue = lazy(() => import("@/pages/NutritionRevenue"));
